import styled from 'styled-components';

export const MainWrapper = styled.div.attrs({
  className: 'col-12 p-0'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  height: calc(100vh - 184px);

  @media (max-width: 960px) {
    height: calc(100vh - 220px);
  }
`

export const LeftCol = styled.div`
  display: flex;
  flex: 3;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex: 2.5;
  }
`

export const RightCol = styled.div`
  display: flex;
  flex: 7;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex: 7.5;
  }
`